import { ChangeDetectorRef, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { AppSnackBaseComponent } from '../../../shared/components/snacks/snack-base.component';

export enum InsightsLibraryToggleHomeSnackDataAction {
  Added = 'Added',
  Removed = 'Removed'
}

export interface InsightsLibraryToggleHomeSnackData {
  itemName: string;
  destination: string;
  action: InsightsLibraryToggleHomeSnackDataAction;
};

@Component({
  selector: 'app-insights-library__added-to-home-snack',
  template: `
    <div class="text-center">
      <div class="fs-16">
      <strong>{{data.itemName}}</strong><span> has been <strong>{{data.action}}</strong>{{data.action === insightsLibraryToggleHomeSnackDataAction.Added ? ' to' : ' from' }} </span>
      <strong>{{data.destination}}</strong>
      </div>
    </div>`,
  encapsulation: ViewEncapsulation.None,
  host: { 'class': 'mat-simple-snackbar' },
  standalone: false
})
export class InsightsLibraryToggleHomeSnack extends AppSnackBaseComponent {
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    snackBarRef: MatSnackBarRef<InsightsLibraryToggleHomeSnack>,
    @Inject(MAT_SNACK_BAR_DATA) public data: InsightsLibraryToggleHomeSnackData) {
    super(changeDetectorRef, snackBarRef);
  }

  public insightsLibraryToggleHomeSnackDataAction: typeof InsightsLibraryToggleHomeSnackDataAction = InsightsLibraryToggleHomeSnackDataAction;
};
